import { ref } from 'vue'
import { defineStore } from 'pinia'

export interface SidebarLinkItem {
  label: string;
  to?: string;
  icon: string;
  children?: SidebarLinkItem[];
  meta?: {
    requiresAdmin?: boolean;
  };
}

export const useNavigationStore = defineStore('navigation', () => {
  const sidebarLinks: SidebarLinkItem[] = [
    { label: 'Dashboard', to: '/dashboard', icon: 'ic:round-dashboard' },
    { label: 'Yarn', to: '/yarns', icon: 'ph:yarn-fill' },
    { label: 'Batches', to: '/batches', icon: 'clarity:file-group-solid' },
    { label: 'Rolls', to: '/rolls', icon: 'game-icons:rolled-cloth' },
    { label: 'Orders', to: '/orders', icon: 'material-symbols:orders-rounded' },
    { label: 'Packing List & Invoice', to: '/packingList', icon: 'ep:list' },
    { label: 'Product Specification', to: '/productSpecification', icon: 'dashicons:products' },
    { label: 'Suppliers', to: '/suppliers', icon: 'mdi:truck-fast' },
    { label: 'Customers', to: '/customers', icon: 'fluent:people-team-32-filled' },
    {
      label: 'Reports',
      icon: 'mdi:file-report',
      children: [
        { label: 'Production By Machine', to: '/productionByMachine', icon: 'mdi:robot-industrial' },
        { label: 'Production By Quality', to: '/productionByQuality', icon: 'ph:seal-check-fill' },
        { label: 'Production By Supplier', to: '/productionBySupplier', icon: 'mdi:factory' },
        { label: 'Sales By Customer', to: '/salesByCustomer', icon: 'mdi:account-cash' },
        { label: 'Sales By Quality', to: '/salesByQuality', icon: 'mdi:account-cash' },
        { label: 'Cost to Sale Analysis', to: '/costToSaleAnalysis', icon: 'mdi:chart-line' },
        { label: 'Yarn Stock Value', to: '/yarnStockValue', icon: 'mdi:warehouse' },
        { label: 'Batch Stock', to: '/batchStock', icon: 'mdi:format-list-bulleted-square' }
      ]
    },
    {
      label: 'Admin',
      icon: 'eos-icons:admin',
      children: [
        { label: 'Users', to: '/users', icon: 'flowbite:users-solid' },
        { label: 'Yarn Type', to: '/yarn-type', icon: 'ph:yarn' }
      ],
      meta: { requiresAdmin: true }
    }
  ]

  const isSidebarExpanded = ref(true)
  const toggleSidebar = () => {
    isSidebarExpanded.value = !isSidebarExpanded.value
  }

  return { isSidebarExpanded, toggleSidebar, sidebarLinks }
})